import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService, User } from '../auth/auth.service';
import { UserRoles } from 'src/models/user-roles';

export const authGuard: CanActivateFn = (route, state) => {
  const authService = inject(AuthService);
  const router = inject(Router);

  let user = authService.loggedInUser
  if (user.role === UserRoles.GUEST) {
    router.navigate(['/login']);  
    return false
  } else {
    return true;
  }
};
